let apiUrl = process.env.REACT_APP_API_URL;
if (apiUrl && apiUrl.includes('localhost') && typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
  apiUrl = apiUrl.replace('localhost', window.location.hostname);
}

const config = {
  apiUrl: apiUrl,
  appName: process.env.REACT_APP_APP_NAME || 'Harvyq ERP',
  appVersion: process.env.REACT_APP_APP_VERSION || '1.0.0',
  currency: process.env.REACT_APP_CURRENCY || 'KES',
  currencySymbol: process.env.REACT_APP_CURRENCY_SYMBOL || 'KSh',
  dateFormat: process.env.REACT_APP_DATE_FORMAT || 'DD/MM/YYYY',
  timeFormat: process.env.REACT_APP_TIME_FORMAT || 'HH:mm',
  defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 20,
  maxPageSize: parseInt(process.env.REACT_APP_MAX_PAGE_SIZE) || 100,
  sessionTimeout: parseInt(process.env.REACT_APP_SESSION_TIMEOUT) || 60,
  refreshTokenInterval: parseInt(process.env.REACT_APP_REFRESH_TOKEN_INTERVAL) || 30,
  maxUploadSize: parseInt(process.env.REACT_APP_MAX_UPLOAD_SIZE) || 10485760,
  allowedFileTypes: process.env.REACT_APP_ALLOWED_FILE_TYPES?.split(',') || ['.jpg', '.jpeg', '.png'],
  isDebug: process.env.REACT_APP_DEBUG === 'true',
  isDemo: process.env.REACT_APP_DEMO_MODE === 'true',
  features: {
    mpesa: process.env.REACT_APP_ENABLE_MPESA === 'true',
    cardPayments: process.env.REACT_APP_ENABLE_CARD_PAYMENTS === 'true',
    barcodeScanner: process.env.REACT_APP_ENABLE_BARCODE_SCANNER === 'true',
    receiptPrinting: process.env.REACT_APP_ENABLE_RECEIPT_PRINTING === 'true',
    bulkUpload: process.env.REACT_APP_ENABLE_BULK_UPLOAD === 'true',
    debtTracking: process.env.REACT_APP_ENABLE_DEBT_TRACKING === 'true'
  },
  support: {
    email: process.env.REACT_APP_SUPPORT_EMAIL || 'support@harvyq.com',
    phone: process.env.REACT_APP_SUPPORT_PHONE || '+254726642205'
  }
};

export default config;